import React from "react";
import PropTypes from "prop-types";

const Pill = ({ color, children, style }) => {
  const bgColor = color ? { backgroundColor: color } : {};
  const styles = { fontSize: "0.8rem", color: "white", ...style, ...bgColor };
  return (
    <span
      className="badge badge-pill tag tag-pill tw-text-white tw-bg-coolGray-800"
      style={styles}
    >
      {children}
    </span>
  );
};

Pill.propTypes = {
  color: PropTypes.string,
  style: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
};

Pill.defaultProps = {
  color: null,
  style: {},
  children: "",
};

export default Pill;
